export const state = {
  addAssign: {
    name: '',
    type: 0
  },
  updateAssign: {},
  assign: {
    id: '',
    name: '',
    type: ''
  },
  assigns: [],
  exportData: [],
  total: 0,
  selectedAssignList: [],
  typeList: [
    {
      id: 1,
      name: '赤',
      border: '#DF3000',
      background: '#E95504',
      text: '#FFFFFF'
    },
    {
      id: 2,
      name: '黄',
      border: '#928C00',
      background: '#FFF100',
      text: '#000000'
    },
    {
      id: 3,
      name: '緑',
      border: '#007D5D',
      background: '#00A283',
      text: '#FFFFFF'
    },
    {
      id: 4,
      name: '青',
      border: '#20387F',
      background: '#0079C2',
      text: '#FFFFFF'
    },
    {
      id: 5,
      name: '空色',
      border: '#30A6EB',
      background: '#54C2F0',
      text: '#0041FF'
    },
    {
      id: 6,
      name: 'ピンク',
      border: '#EB8AB2',
      background: '#F4B5D0',
      text: '#5D0C75'
    },
    {
      id: 7,
      name: '紫',
      border: '#5D0C75',
      background: '#5D0C75',
      text: '#FFFFFF'
    },
    {
      id: 8,
      name: '茶色',
      border: '#652810',
      background: '#8A4824',
      text: '#FFFFFF'
    }
  ]
}
export const mutations = {
  setAssigns(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
      state.total = 0
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      if (
        state.selectedAssignList.some(
          selectedAssign =>
            selectedAssign.id === response.data['data'][i]['id']
        )
      ) {
        response.data['data'][i]['checked'] = true
      } else {
        response.data['data'][i]['checked'] = false
      }
    }
    state.assigns = response.data['data']
    state.total = response.data['header']['total']
  },
  setDetail(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = ''
    }
    state.assign = response.data['data']
    state.updateAssign = {}
    state.updateAssign.id = state.assign.id
    state.updateAssign.name = state.assign.name
    state.updateAssign.type = state.assign.type
  },
  inputUpdate(state, payload) {
    state.updateAssign[payload.name] = payload.value
  },
  inputAddUpdate(state, payload) {
    state.addAssign[payload.name] = payload.value
  },
  clearAssign(state) {
    state.addAssign = {}
    var defaultType = 1
    state.addAssign.type = defaultType
  },
  updateSelectedAssignList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedAssignList.some(assign => assign.id === payload[i].id)
      ) {
        state.selectedAssignList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedAssignList.some(assign => assign.id === payload[i].id)
      ) {
        const deleteIndex = state.selectedAssignList.findIndex(
          assign => assign.id === payload[i].id
        )
        state.selectedAssignList = state.selectedAssignList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearSelectedAssignList(state) {
    state.selectedAssignList = []
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/assignModules/assignMutation.js